import { useEffect, useRef } from 'react';

import { CLIENT_STORAGE_QUERY_KEYS } from '@/entities/clientStorage';
import { clearEntrySource, ENTRY_SOURCE_KEY } from '@/entities/entrySource';
import { useCognitoCheckUser } from '@/entities/user/currentUser';

import { queryClient } from '@/shared/config';

export const AuthLostWatcher = () => {
  const { data } = useCognitoCheckUser({ enabled: false });
  const isAuthenticated = Boolean(data?.isAuthorized);
  const wasAuthenticated = useRef(isAuthenticated);

  useEffect(() => {
    if (wasAuthenticated.current && !isAuthenticated) {
      clearEntrySource();
      queryClient.removeQueries({
        queryKey: CLIENT_STORAGE_QUERY_KEYS.item(ENTRY_SOURCE_KEY),
      });
    }
    wasAuthenticated.current = isAuthenticated;
  }, [isAuthenticated]);

  return null;
};
